module.exports = __webpack_public_path__ + "static/media/mg.65482ca5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mg.svg
// module id = 187
// module chunks = 0